<template>
    <div>
        <a-config-provider :locale="antdLocale">
            <a-card>
                <a-tabs @change="tabChange">
                    <a-tab-pane :tab="l('General')" key="1">
                        <a-row>
                            <!-- 图片质量 -->
                            <a-col :span="24">
                                <p class="text">{{l('PictureSettings')}}</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;">
                                <!-- PictureQuality 图片质量 -->
                                <div style="margin-left: 15px;line-height: 35px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('PictureQuality') + '：'}}
                                    </span>
                                </div>
                                <a-select style="width: 300px;text-align: left;margin-right: 10px;"
                                    dropdownClassName="drop-down-Style" :dropdownMatchSelectWidth="false"
                                    :placeholder="l('please_select_Picture_Quality')" default-value="1"
                                    v-model="PictureQuality">
                                    <a-select-option v-for="item in PictureQualityList" :key="item.value"
                                        :title="item.name">
                                        {{ item.name +' '+item.resolutionratio }}
                                    </a-select-option>
                                </a-select>
                            </a-col>
                            <a-col :span="24" style="margin-top: 15px;">
                                <a-button :type="'primary'" @click="save()" v-if="isGranted('other_save')">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>
                            </a-col>

							<!-- 视频设置 -->
							<a-col :span="24" style="margin-top: 30px;">
							    <p class="text">{{ l('VideoSettings') }}</p>
							</a-col>
							<a-col :span="24" style="display: flex;">
							    <p style="margin: auto 0;">{{ l('Video_Duration') + '：' }}</p>
							    <a-input-number v-model="VideoDuration" style="width: 100px;" :min="0" :max="60"
							        :formatter="value => `${value}` + l('Second')"
							        :parser="value => value.replace(l('Second'), '')"></a-input-number>
							</a-col>
							
							<a-col :span="24" style="display: flex;margin-top: 10px;">
							    <p style="margin: auto 0;">{{ l('Video_Quality') + '：' }}</p>
							    <a-select :filterOption="filterOption" style="width: 150px;margin-left: 10px;"
							        v-model="VideoResolution" :placeholder="l('Video_Quality_Configuration')" @change="VideoResolutionChange"
							        allow-clear>
							        <a-select-option v-for="item in VideoResolutionList" :key="item.itemDetailCode"
							            :title="item.itemDetailName">
							            {{ item.itemDetailName }}
							        </a-select-option>
							    </a-select>
							</a-col>
							
							<a-col :span="24" style="margin-top: 10px;">
							    <img src="../../../../public/img/image/resolutionRatio.png" />
							</a-col>
							
							<a-col :span="24" style="margin-top: 15px;">
							    <a-button :type="'primary'" @click="videoSave()" v-if="isGranted('other_save')">
							        <a-icon type="save" />
							        <span>{{ l('Save') }}</span>
							    </a-button>
							</a-col>

                            <!-- 私钥 -->
                            <a-col :span="24" style="margin-top: 20px;" v-if="TenantId == 10">
                                <a-input v-model="Privatekey" class="input"
                                    style="color: black;width: 300px; margin: 10px 10px 0 0; "
                                    :placeholder="l('PrivateKey')"></a-input>
                                <a-button :type="'primary'" @click="GeneratePrivatekey()">
                                    <a-icon />
                                    <span>{{ l('GenerateAPrivateKey') }}</span>
                                </a-button>
                            </a-col>
                            <a-col :span="24" style="margin-top: 15px;" v-if="TenantId == 10">
                                <a-button :type="'primary'" @click="savePrivatekey()">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>
                            </a-col>


                            <!-- 域信息配置 -->
                            <a-col :span="24" style="margin-top: 20px;">
                                <!-- <p class="text">{{l('LdapConfiguration')}}</p> -->
                                <p class="text">windows用户免登录配置</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Whether_it_is_enabled') + '：'}}
                                    </span>
                                </div>
                                <a-checkbox v-model="LdapIsActivate">
                                    {{l('enable')}}
                                </a-checkbox>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Domain_server_address') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="LdapDomainName" class="input"
                                    style="color: black;width: 300px; margin: 10px 10px 0 0; "
                                    :placeholder="l('Domain_server_address')"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Domain_DN_address') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="LdapContainer" class="input"
                                    style="color: black;width: 300px; margin: 10px 10px 0 0; "
                                    :placeholder="l('Domain_DN_address')"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Domain_account') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="LdapUserName" class="input"
                                    style="color: black;width: 300px; margin: 10px 10px 0 0; "
                                    :placeholder="l('Domain_account')"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Domain_password') + '：'}}
                                    </span>
                                </div>
                                <a-input-password v-model="LdapPassword" class="input"
                                    style="color: black;width: 300px; margin: 10px 10px 0 0; "
                                    :placeholder="l('Domain_password')"></a-input-password>
                            </a-col>

                            <a-col :span="24" style="margin-top: 15px;">
                                <a-button :type="'primary'" @click="saveLdapSetting()" v-if="isGranted('other_save')">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>

                                <a-button :type="'primary'" @click="testLdapSetting()">
                                    <a-icon type="link" />
                                    <span>{{ l('AppTest') }}</span>
                                </a-button>
                                <span
                                    style="margin-left: 10px;">{{l('Save_the_LDAP_configuration_before_testing')}}</span>
                            </a-col>
                        </a-row>
                    </a-tab-pane>
                    <a-tab-pane :tab="l('短信配置')" key="2">

                        <a-row>
                            <!-- 短信配置 -->
                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text">{{l('Whether_it_is_enabled')}}</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('enable') + '：'}}
                                    </span>
                                </div>
                                <a-checkbox v-model="textmessageIsActivate">
                                    {{l('enable')}}
                                </a-checkbox>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('短信平台地址') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="textmessageSMS_Addr" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    :placeholder="l('短信平台地址')"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('短信平台账号') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="textmessageSMS_Account" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    :placeholder="l('短信平台账号')"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>
                                        {{l('Key值') + '：'}}
                                    </span>
                                </div>
                                <a-input v-model="textmessageSMS_Key" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    :placeholder="l('Key值')"></a-input>
                            </a-col>

                            <a-col :span="24" style="margin-top: 15px;">
                                <a-button :type="'primary'" @click="savetextmessageSetting()">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-tab-pane>
                    <a-tab-pane :tab="l('企业微信配置')" key="3">
                        <a-row>
                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text">{{l('Whether_it_is_enabled')}}</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>{{l('enable')}}:</span>
                                </div>
                                <a-checkbox v-model="weComEnabled">
                                    {{l('enable')}}
                                </a-checkbox>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>BaseUrl:</span>
                                </div>
                                <a-input v-model="weComBaseUrl" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="BaseUrl"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>CorpId:</span>
                                </div>
                                <a-input v-model="weComCorpId" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="CorpId"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>AgentId:</span>
                                </div>
                                <a-input v-model="weComAgentId" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="AgentId"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>Secret:</span>
                                </div>
                                <a-input-password v-model="weComSecret" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="Secret"></a-input-password>
                            </a-col>
                            <a-col :span="24" style="margin-top: 15px;">
                                <a-button :type="'primary'" @click="saveWeComSetting()">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-tab-pane>
                    <a-tab-pane :tab="l('钉钉配置')" key="4">
                        <a-row>
                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text">{{l('Whether_it_is_enabled')}}</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>{{l('enable')}}:</span>
                                </div>
                                <a-checkbox v-model="dingTalkEnabled">
                                    {{l('enable')}}
                                </a-checkbox>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>BaseUrl:</span>
                                </div>
                                <a-input v-model="dingTalkBaseUrl" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="BaseUrl"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>CorpId:</span>
                                </div>
                                <a-input v-model="dingTalkCorpId" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="CorpId"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>AgentId:</span>
                                </div>
                                <a-input v-model="dingTalkAgentId" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="AgentId"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>AppKey:</span>
                                </div>
                                <a-input v-model="dingTalkAppKey" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="AppKey"></a-input>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: -5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>AppSecret:</span>
                                </div>
                                <a-input-password v-model="dingTalkAppSecret" class="input"
                                    style="color: black;width: 80%; margin: 10px 10px 0 0; "
                                    placeholder="AppSecret"></a-input-password>
                            </a-col>
                            <!-- 暂不启用日报小程序跳转配置。
                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text" style="font-size: 16px;">小程序跳转</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;line-height: 50px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>日报页面:</span>
                                </div>
                                <div style="width: 80%;">
                                    <a-input v-model="dingTalkDailyAuditTaskReportPagePath" class="input"
                                        style="color: black;width: 100%; margin: 10px 10px 0 0;"
                                        placeholder="pages/audit-task/list?sceneId=@sceneId&date=@date"></a-input>
                                    <div class="tips-text">企业内部小程序使用页面路径即可。系统发送时会自动转换为 eapp:// 链接。</div>
                                </div>
                            </a-col>
                            -->
                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text" style="font-size: 16px;">同步部门</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;align-items: flex-start;">
                                <div style="margin-left: 15px;line-height: 34px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>部门选择:</span>
                                </div>
                                <div style="width: 80%;">
                                    <a-tree-select
                                        v-model="dingTalkSyncDepartmentIds"
                                        style="width: 100%;"
                                        :tree-data="dingTalkDepartmentTree"
                                        :replace-fields="dingTalkTreeReplaceFields"
                                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                        :dropdownMatchSelectWidth="false"
                                        tree-checkable
                                        multiple
                                        tree-default-expand-all
                                        allow-clear
                                        :disabled="!dingTalkEnabled"
                                        placeholder="请选择需要同步的钉钉部门">
                                    </a-tree-select>
                                    <div class="tips-text">系统不落库存储钉钉部门主数据，这里实时从钉钉拉取，仅保存同步范围。</div>
                                </div>
                            </a-col>

                            <a-col :span="24" style="margin-top: 20px;">
                                <p class="text" style="font-size: 16px;">同步策略</p>
                            </a-col>
                            <a-col :span="24" style="display: flex;margin-top: 5px;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>实时增量:</span>
                                </div>
                                <div>
                                    <a-checkbox v-model="dingTalkStreamEnabled">启用 Stream 实时增量同步</a-checkbox>
                                    <div class="tips-text">实时增量事件同样只处理当前已选部门范围内的员工。</div>
                                </div>
                            </a-col>

                            <a-col :span="24" style="display: flex;margin-top: 12px;">
                                <div style="margin-left: 15px;"
                                    :style="{'width': language == 'zh-Hans' ? '100px' : '120px'}">
                                    <span>每日全量:</span>
                                </div>
                                <div style="display: flex;align-items: center;">
                                    <a-checkbox v-model="dingTalkDailySyncEnabled">启用每日定时全量同步</a-checkbox>
                                    <a-input v-model="dingTalkDailySyncTime"
                                        :disabled="!dingTalkDailySyncEnabled"
                                        style="color: black;width: 120px; margin-left: 12px;"
                                        placeholder="HH:mm"></a-input>
                                </div>
                            </a-col>

                            <a-col :span="24" style="margin-top: 15px;">
                                <a-button :type="'primary'" @click="saveDingTalkSetting()">
                                    <a-icon type="save" />
                                    <span>{{ l('Save') }}</span>
                                </a-button>
                                <a-button style="margin-left: 8px;" @click="loadDingTalkDepartments()">
                                    <a-icon type="reload" />
                                    <span>拉取部门</span>
                                </a-button>
                                <a-button style="margin-left: 8px;" @click="syncDingTalkUsers()">
                                    <a-icon type="team" />
                                    <span>同步员工</span>
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-tab-pane>
                </a-tabs>
            </a-card>
        </a-config-provider>
    </div>
</template>

<script>
    import {
        AppComponentBase
    } from "@/shared/component-base";
    import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
    import {
        IssueServiceProxy,
        EHSServiceProxy,
        SystemConfigServiceProxy,
        TenantSettingsServiceProxy,
        HostSettingsServiceProxy
    } from '../../../shared/service-proxies';
    import {
        ModalHelper
    } from '@/shared/helpers';
    import { abpService } from '@/shared/abp';
	import { Dic, fileDownloadService } from "../../../shared/utils";
    import apiHttpClient from '@/shared/utils/api-http-client';

    let _this;
    export default {
        name: "system-config",
        mixins: [AppComponentBase],
        components: {

        },
        created() {
            _this = this;
            this.form = this.$form.createForm(this, { name: "register" });
            this.IssueServiceProxy = new IssueServiceProxy(this.$apiUrl, this.$api);
            this.EHSServiceProxy = new EHSServiceProxy(this.$apiUrl, this.$api);
            this.SystemConfigServiceProxy = new SystemConfigServiceProxy(this.$apiUrl, this.$api);
            this._tenantSettingServiceProxy = new TenantSettingsServiceProxy(this.$apiUrl, this.$api);
            this._hostSettingsServiceProxy = new HostSettingsServiceProxy(
                this.$apiUrl,
                this.$api
            );
        },
        async mounted() {
			this.VideoResolutionList = await Dic.getInstance().getDicAsync('VideoResolution');
            this.language = localStorage.getItem('leanasst-language');
            this.TenantId = abpService.abp.multiTenancy.getTenantIdCookie();
            this.getPictureQuality();
            this.getPrivatekey();
            this.getLdapSetting();
            this.gettextmessageSetting();
            this.getWeComSetting();
            this.getDingTalkSetting();
			this.getVideoDuration();
			this.getVideoResolution();
        },
        data() {
            return {
                zh_CN,
                isEdit: false,
                isLook: false,
                isLoading: false,
                photo: false,
                remark: false,
                date: {},
                remarkDate: {},
                IsRequiredIssueResp: false,
                IsRequiredPhotoIssueResp: false,
                Privatekey: undefined,
                PictureQuality: undefined,
                PictureQualityList: [
                    {
                        value: '1,0.3',
                        name: '小尺寸',
                        resolutionratio: '1280*720p',
                        scale: 0.3,
                        size: 200
                    },
                    {
                        value: '2,0.5',
                        name: '清晰',
                        resolutionratio: '1280*720p',
                        scale: 0.5,
                        size: 500
                    },
                    {
                        value: '3,0.7',
                        name: '高清',
                        resolutionratio: '1920*1080p',
                        scale: 0.7,
                        size: 1000
                    }
                ],
                tokenExpiration: undefined,

                LdapIsActivate: false,
                LdapDomainName: undefined,
                LdapContainer: undefined,
                LdapUserName: undefined,
                LdapPassword: undefined,
                language: 'zh-Hans',
                TenantId: 0,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 2 },
                        sm: { span: 2 }
                    },
                    wrapperCol: {
                        xs: { span: 10 },
                        sm: { span: 10 }
                    }
                },
                textmessageIsActivate: false,
                textmessageSMS_Addr: undefined,
                textmessageSMS_Account: undefined,
                textmessageSMS_Key: undefined,
                weComEnabled: false,
                weComBaseUrl: undefined,
                weComCorpId: undefined,
                weComAgentId: undefined,
                weComSecret: undefined,
                dingTalkEnabled: false,
                dingTalkBaseUrl: undefined,
                dingTalkCorpId: undefined,
                dingTalkAgentId: undefined,
                dingTalkAppKey: undefined,
                dingTalkAppSecret: undefined,
                dingTalkSyncDepartmentIds: [],
                dingTalkStreamEnabled: false,
                dingTalkDailySyncEnabled: false,
                dingTalkDailySyncTime: '02:30',
                dingTalkDailyAuditTaskReportPagePath: undefined,
                dingTalkDepartmentTree: [],
                dingTalkDepartmentLoading: false,
                dingTalkTreeReplaceFields: {
                    title: 'title',
                    key: 'key',
                    value: 'key',
                    children: 'children'
                },
				VideoDuration: 60,
				VideoResolution: undefined,
				VideoResolutionList: [],
            }
        },
        methods: {
            getPictureQuality() {
                this.isLoading = true;
                this.SystemConfigServiceProxy.getPictureQuality()
                    .finally(() => {
                        this.isLoading = false;
                    }).then(res => {
                        this.PictureQuality = res;
                    })
            },
            save() {
                //图片质量
                this.isLoading = true;
                this.SystemConfigServiceProxy.pictureQuality(
                    { PictureQuality: this.PictureQuality }
                ).finally(() => {
                    this.isLoading = false;
                }).then(res => {
                })

                this.$notification.success({
                    description: undefined,
                    message: this.l('SavedSuccessfully'),
                });
            },
			
			//视频时长
			getVideoDuration() {
			    this.isLoading = true;
			    this.SystemConfigServiceProxy.getVideoDuration(
			
			    ).finally(() => {
			        this.isLoading = false;
			
			    }).then(res => {
			        this.VideoDuration = res;
			    })
			},
			
			//视频分辨率
			getVideoResolution() {
			    this.isLoading = true;
			    this.SystemConfigServiceProxy.getVideoResolution(
			
			    ).finally(() => {
			        this.isLoading = false;
			
			    }).then(res => {
			        this.VideoResolution = res;
			    })
			},
			
			VideoResolutionChange(value) {
			    this.VideoResolution = value;
			},
			
			videoSave() {
				//视频时长
				this.isLoading = true;
				this.SystemConfigServiceProxy.videoDuration(
				    { VideoDuration: this.VideoDuration }
				).finally(() => {
				    this.isLoading = false;
				}).then(res => {
				})
				
				//视频分辨率
				this.isLoading = true;
				this.SystemConfigServiceProxy.videoResolution(
				    { VideoResolution: this.VideoResolution }
				).finally(() => {
				    this.isLoading = false;
				}).then(res => {
				})
			},

            getPrivatekey() {
                this.isLoading = true;
                this.EHSServiceProxy.getEHSPrivatekey(

                ).finally(() => {
                    this.isLoading = false;
                }).then(res => {
                    this.Privatekey = res;
                })
            },

            GeneratePrivatekey() {
                console.log(1);
                this.isLoading = true;
                this.EHSServiceProxy.generatePrivatekey()
                    .finally(() => {
                        this.isLoading = false;
                    }).then(res => {
                        this.Privatekey = res;
                    })
            },
            savePrivatekey() {
                this.isLoading = true;
                this.EHSServiceProxy.eHSPrivatekey(
                    {
                        EHSPrivatekey: this.Privatekey
                    }
                ).finally(() => {
                    this.isLoading = false;
                }).then(res => {
                })

                this.$notification.success({
                    description: undefined,
                    message: this.l('SavedSuccessfully'),
                });
            },



            getLdapSetting() {
                this.isLoading = true;
                this.SystemConfigServiceProxy.getLdapSetting()
                    .finally(() => {
                        this.isLoading = false;
                    }).then(res => {
                        this.LdapIsActivate = res.ldapIsActivate;
                        this.LdapDomainName = res.ldapDomainName;
                        this.LdapContainer = res.ldapContainer;
                        this.LdapUserName = res.ldapUserName;
                        this.LdapPassword = res.ldapPassword;
                    })
            },
            saveLdapSetting() {
                //ldap
                this.isLoading = true;
                this.SystemConfigServiceProxy.ldapSetting(
                    {
                        LdapIsActivate: this.LdapIsActivate,
                        LdapDomainName: this.LdapDomainName,
                        LdapContainer: this.LdapContainer,
                        LdapUserName: this.LdapUserName,
                        LdapPassword: this.LdapPassword
                    }
                ).finally(() => {
                    this.isLoading = false;
                }).then(res => {
                })

                this.$notification.success({
                    description: undefined,
                    message: this.l('SavedSuccessfully'),
                });
            },

            testLdapSetting() {
                this.isLoading = true;
                this.SystemConfigServiceProxy.testLdapSetting()
                    .finally(() => {
                        this.isLoading = false;
                    }).then(res => {
                        if (!res) {
                            abp.message.info('连接失败，请检查配置信息');
                            return;
                        }
                        else {
                            abp.message.success('连接成功');
                            return;
                        }
                    })
            },

            gettextmessageSetting() {
                this._tenantSettingServiceProxy
                    .getAllSettings()
                    .finally(() => { })
                    .then(res => {
                        if (res.textMessage.smS_IsActivate == null) {
                            res.textMessage.smS_IsActivate = false;
                        }
                        this.textmessageIsActivate = res.textMessage.smS_IsActivate;
                        this.textmessageSMS_Addr = res.textMessage.smS_Addr;
                        this.textmessageSMS_Account = res.textMessage.smS_Account;
                        this.textmessageSMS_Key = res.textMessage.smS_Key;
                    });
            },

            tabChange(data) {
                if (
                    data === '4' &&
                    this.dingTalkEnabled &&
                    (!this.dingTalkDepartmentTree || this.dingTalkDepartmentTree.length === 0)
                ) {
                    this.loadDingTalkDepartments();
                }
            },

            savetextmessageSetting() {
                this.spinning = true;
                var obj = {textMessage:{
                    smS_IsActivate : this.textmessageIsActivate,
                    smS_Addr : this.textmessageSMS_Addr,
                    smS_Account  : this.textmessageSMS_Account,
                    smS_Key : this.textmessageSMS_Key
                }};
                this._tenantSettingServiceProxy
                    .updateAllSettings(obj)
                    .finally(() => {
                        this.spinning = false;
                    })
                    .then(result => {
                        this.notify.success(this.l("SavedSuccessfully"));
                    });
            },
            getWeComSetting() {
                this._tenantSettingServiceProxy
                    .getAllSettings()
                    .finally(() => { })
                    .then(res => {
                        const weCom = res.weCom || {};
                        if (weCom.enabled == null) {
                            weCom.enabled = false;
                        }
                        this.weComEnabled = weCom.enabled;
                        this.weComBaseUrl = weCom.baseUrl;
                        this.weComCorpId = weCom.corpId;
                        this.weComAgentId = weCom.agentId;
                        this.weComSecret = weCom.secret;
                    });
            },
            saveWeComSetting() {
                this.spinning = true;
                const obj = {
                    weCom: {
                        enabled: this.weComEnabled,
                        baseUrl: this.weComBaseUrl,
                        corpId: this.weComCorpId,
                        agentId: this.weComAgentId,
                        secret: this.weComSecret
                    }
                };
                this._tenantSettingServiceProxy
                    .updateAllSettings(obj)
                    .finally(() => {
                        this.spinning = false;
                    })
                    .then(() => {
                        this.notify.success(this.l("SavedSuccessfully"));
                    });
            },
            getDingTalkSetting() {
                this._tenantSettingServiceProxy
                    .getAllSettings()
                    .finally(() => { })
                    .then(res => {
                        const settings = (res && res.result) || res || {};
                        const dingTalk = settings.dingTalk || settings.DingTalk || {};
                        if (dingTalk.enabled == null) {
                            dingTalk.enabled = false;
                        }
                        if (dingTalk.streamEnabled == null) {
                            dingTalk.streamEnabled = false;
                        }
                        if (dingTalk.dailySyncEnabled == null) {
                            dingTalk.dailySyncEnabled = false;
                        }
                        this.dingTalkEnabled = dingTalk.enabled;
                        this.dingTalkBaseUrl = dingTalk.baseUrl;
                        this.dingTalkCorpId = dingTalk.corpId;
                        this.dingTalkAgentId = dingTalk.agentId;
                        this.dingTalkAppKey = dingTalk.appKey;
                        this.dingTalkAppSecret = dingTalk.appSecret;
                        this.dingTalkSyncDepartmentIds = this.parseDepartmentIds(dingTalk.syncDepartmentIds);
                        this.dingTalkStreamEnabled = dingTalk.streamEnabled;
                        this.dingTalkDailySyncEnabled = dingTalk.dailySyncEnabled;
                        this.dingTalkDailySyncTime = dingTalk.dailySyncTime || '02:30';
                        this.dingTalkDailyAuditTaskReportPagePath = dingTalk.dailyAuditTaskReportPagePath;
                    });
            },
            saveDingTalkSetting() {
                this.spinning = true;
                const obj = {
                    dingTalk: {
                        enabled: this.dingTalkEnabled,
                        baseUrl: this.dingTalkBaseUrl,
                        corpId: this.dingTalkCorpId,
                        agentId: this.dingTalkAgentId,
                        appKey: this.dingTalkAppKey,
                        appSecret: this.dingTalkAppSecret,
                        syncDepartmentIds: (this.dingTalkSyncDepartmentIds || []).join(','),
                        streamEnabled: this.dingTalkStreamEnabled,
                        dailySyncEnabled: this.dingTalkDailySyncEnabled,
                        dailySyncTime: this.dingTalkDailySyncTime,
                        dailyAuditTaskReportPagePath: this.dingTalkDailyAuditTaskReportPagePath
                    }
                };
                this._tenantSettingServiceProxy
                    .updateAllSettings(obj)
                    .finally(() => {
                        this.spinning = false;
                    })
                    .then(() => {
                        this.notify.success(this.l("SavedSuccessfully"));
                        if (this.dingTalkEnabled && (!this.dingTalkDepartmentTree || this.dingTalkDepartmentTree.length === 0)) {
                            this.loadDingTalkDepartments();
                        }
                    });
            },
            async loadDingTalkDepartments() {
                if (!this.dingTalkEnabled) {
                    return;
                }
                this.dingTalkDepartmentLoading = true;
                try {
                    const res = await apiHttpClient.get('/api/services/app/TenantSettings/GetDingTalkDepartments');
                    const payload = (res && res.data) || [];
                    this.dingTalkDepartmentTree = this.normalizeDingTalkDepartmentNodes(payload);
                } finally {
                    this.dingTalkDepartmentLoading = false;
                }
            },
            async syncDingTalkUsers() {
                this.spinning = true;
                try {
                    const res = await apiHttpClient.post('/api/services/app/User/SyncDingTalkUsers', {});
                    const result = (res && res.data) || {};
                    const total = result.totalCount == null
                        ? (result.totalDingTalkUsers == null ? 0 : result.totalDingTalkUsers)
                        : result.totalCount;
                    const updated = result.updatedCount == null ? 0 : result.updatedCount;
                    const created = result.createdCount == null ? 0 : result.createdCount;
                    this.notify.success(`同步完成，共 ${total} 个，更新 ${updated} 个，新建 ${created} 个`);
                } finally {
                    this.spinning = false;
                }
            },
            parseDepartmentIds(value) {
                if (Array.isArray(value)) {
                    return value.map(item => `${item}`).filter(item => item);
                }
                if (!value) {
                    return [];
                }
                return `${value}`
                    .split(',')
                    .map(item => item.trim())
                    .filter(item => item);
            },
            normalizeDingTalkDepartmentNodes(nodes) {
                if (!Array.isArray(nodes)) {
                    return [];
                }
                return nodes.map(item => ({
                    title: item.title || item.Title || '',
                    key: `${item.key || item.Key || ''}`,
                    value: `${item.value || item.Value || item.key || item.Key || ''}`,
                    isLeaf: item.isLeaf !== undefined ? item.isLeaf : !!item.IsLeaf,
                    children: this.normalizeDingTalkDepartmentNodes(item.children || item.Children || [])
                }));
            },

			filterOption(input, option) {
			    return (
			        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
			    );
			},
        }
    }
</script>

<style>
    .pagination {
        margin: 10px auto;
        text-align: right;
    }

    .text {
        font-size: 18px;
        font-weight: bold;
    }

    .tips-text {
        margin-top: 6px;
        color: #8c8c8c;
        line-height: 20px;
    }
</style>
